import { useEffect, useState, type MouseEvent } from 'react';

/** Minimaler Router (History-API): die Shell hat nur Bereichs-/Modulpfade aus der Registry */
export function navigate(path: string) {
  // #839: Pfad inkl. Query vergleichen (Filter in der URL von /crm)
  if (path === window.location.pathname + window.location.search) return;
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePathname(): string {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const on = () => setPath(window.location.pathname);
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return path;
}

/** #839: Query-String der aktuellen URL (z. B. Listenfilter), folgt navigate() und Zurück/Vor */
export function useSearch(): string {
  const [search, setSearch] = useState(window.location.search);
  useEffect(() => {
    const on = () => setSearch(window.location.search);
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return search;
}

/** Link-Handler: Linksklick intern routen, Modifikator-Klicks dem Browser lassen */
export function onLinkClick(path: string) {
  return (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(path);
  };
}
